import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';

interface HeadPhoneStopModalProps {
    isOpen: boolean;
    onClose: () => void;
    onUseSpeaker: () => void;
    onTurnOffVoice: () => void;
    remaining: number;
}

export function HeadPhoneStopModal({ isOpen, onClose, onUseSpeaker, onTurnOffVoice, remaining }: HeadPhoneStopModalProps) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))] tts-modal">
            <div className="flex h-full flex-col">
                <header className="text-text-main01 px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(32*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={0} data-interactive aria-label={t('headPhoneStop.title')} className="focus-border text-center font-bold">
                        {t('headPhoneStop.title')}
                    </h1>
                </header>
                <main className="px-[calc(112*var(--vw-unit))]">
                    <div className="mt-[calc(24*var(--vh-unit))] mb-[calc(40*var(--vh-unit))]">
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={t('headPhoneStop.ariaDescription1', { timeLeft: remaining })}
                            className="text-text-main01 focus-border text-center text-[calc(24*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))]"
                            dangerouslySetInnerHTML={{ __html: t('headPhoneStop.description1', { timeLeft: remaining }) }}
                        ></p>
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={t('headPhoneStop.ariaDescription2')}
                            className="text-text-main01 focus-border mt-[calc(30*var(--vh-unit))] text-center text-[calc(24*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))]"
                            dangerouslySetInnerHTML={{ __html: t('headPhoneStop.description2') }}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center gap-[calc(23*var(--vw-unit))] px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton
                        role="button"
                        variant="tertiary"
                        aria-label={t('headPhoneStop.buttons.continue')}
                        onClick={onUseSpeaker}
                        data-interactive
                        type="button"
                    >
                        {t('headPhoneStop.buttons.continue')}
                    </ModalButton>
                    <ModalButton
                        role="button"
                        variant="secondary"
                        aria-label={t('headPhoneStop.buttons.end')}
                        onClick={onTurnOffVoice}
                        data-interactive
                        type="button"
                    >
                        {t('headPhoneStop.buttons.end')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
